import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './first-run.css'
import { Frame } from './Frame'
import { SetupRail } from './rail'
import { Welcome } from './Welcome'
import { Home, StubPage } from './Home'
import { Composer } from './Composer'
import { TStep, useFirstRun } from './store'
import { BudgetStep, CalendarStep, ConnectStep, PaymentStep, TeamStep, YouStep } from './steps-a'
import { AreaStep, BusinessStep, NumberStep, StopsDoneStep, StopsNeverStep, StopsWorkingStep } from './steps-b'
import { Button, Icon } from './ui'

const STEP_COMPONENTS: Record<TStep, () => JSX.Element> = {
   connect: ConnectStep,
   you: YouStep,
   team: TeamStep,
   calendar: CalendarStep,
   budget: BudgetStep,
   payment: PaymentStep,
   area: AreaStep,
   number: NumberStep,
   'stops-working': StopsWorkingStep,
   'stops-done': StopsDoneStep,
   'stops-never': StopsNeverStep,
   business: BusinessStep,
}

/**
 * The whole first run as UI only: welcome → setup → home → campaign, plus
 * the nav's other pages as stubs. No backend. Developers wire the store's
 * fields to the real services.
 */
export default function FirstRunApp({ view }: { view: 'setup' | 'home' | 'campaign' | 'page' }) {
   const { auth, step, steps, go, reset, setupDone } = useFirstRun()
   const navigate = useNavigate()
   const location = useLocation()
   const { page } = useParams()

   // `/start?step=team` from Settings jumps straight to one screen.
   useEffect(() => {
      const params = new URLSearchParams(location.search)
      const wanted = params.get('step') as TStep | null
      if (view === 'setup' && wanted && steps().includes(wanted)) go(wanted)
      if (params.get('reset') === '1') reset()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location.search, view])

   if (view === 'home') return <Home />
   if (view === 'campaign') return <Composer />
   if (view === 'page') return <StubPage page={page || 'conversations'} />
   if (!auth) return <Welcome />

   const Step = STEP_COMPONENTS[step]
   return (
      <Frame rail={<SetupRail />} right={setupDone ? <Button variant="secondary" size="sm" onClick={() => navigate('/start/home')} testId="to-home"><Icon name="arrow-left" size={14} /> Back to campaigns</Button> : undefined}>
         <Step />
      </Frame>
   )
}
